// spacing
export const spacing = 8

export const majorScale = (inc) => inc * spacing
export const minorScale = (inc) => inc * (spacing / 2)
